import { Suspense } from "react";
import { useAtomValue } from "jotai";
import { Button, Tooltip } from "@zapier/design-system-beta";
import { isZapPublishedAsyncAtomFamily } from "@zapier/canvas-state";

import { useEmitUserInteractionEvents } from "../../hooks/useEmitUserInteractionEvents";
import { buildEditorLink } from "../../utils/buildEditorLink";
import { Icon } from "@zapier/design-system";

type Props = { zapId: string; location: "sidebar" | "node" };

function SuspendedZapLink({ zapId, location }: Props) {
  const isPublished = useAtomValue(isZapPublishedAsyncAtomFamily(zapId));
  const { emitEventOnAssetOpen } = useEmitUserInteractionEvents();

  // This means the zap is not found or a zsl template zap
  if (isPublished === null) {
    return null;
  }

  const editorLink = buildEditorLink(zapId, isPublished);

  return (
    <Tooltip placement="top" content="Open Zap">
      <Tooltip.FocusableTrigger>
        <Button
          size="small"
          onPress={async () => {
            emitEventOnAssetOpen({
              asset: "Zap",
              location,
            });
            window.open(editorLink, "_blank");
          }}
        >
          <Icon name="arrowOffsite" size={20} color="BackgroundDefault" />
          Edit
        </Button>
      </Tooltip.FocusableTrigger>
    </Tooltip>
  );
}

export function ZapLink({ zapId, location }: Props) {
  return (
    <Suspense fallback={null}>
      <SuspendedZapLink zapId={zapId} location={location} />
    </Suspense>
  );
}
